import { axiosInstanceVirtualCard } from "../axios";
import { RequestResponse, WalletCreate, WalletCreations } from "../types";

export const getWallet = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      `/api/v1/wallets/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    console.error("Unable to fetch wallet: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch wallet: Internal server error");
      return {
        error: true,
        message: "Unable to fetch wallet: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getWallets: (
  pageNumber: number,
  pageSize: number,
  name: string
) => Promise<
  RequestResponse<{ records: WalletCreations[]; total: number }>
> = async (pageNumber, pageSize, name) => {
  try {
    const response = await axiosInstanceVirtualCard.get("/api/v1/wallets", {
      params: { page_num: pageNumber, page_size: pageSize, search_query: name }
    });

    return {
      error: false,
      data: {
        records: response.data.data.content,
        total: response.data.data.count
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch wallets: ", { err });
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch wallets: Internal server error");
      return {
        error: true,
        message: "Unable to fetch wallets: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response.data?.message || err.message || err,
      data: null
    };
  }
};

export const deleteWallet = async (id: number): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.delete(`/api/v1/wallets/${id}`);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to delete wallet: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to delete wallets: Internal server error");
      return {
        error: true,
        message: "Unable to delete wallets: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const updateWallet = async (
  id: number,
  payload: WalletCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceVirtualCard.put(`/api/v1/wallets/${id}`, updatedPayload);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update wallet: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to update wallet: Internal server error");
      return {
        error: true,
        message: "Unable to update wallet: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const createWallet = async (
  payload: WalletCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.post(`/api/v1/wallets`, payload);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create wallet: ", err);

    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to create wallet: Internal server error");
      return {
        error: true,
        message: "Unable to create wallet: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
